














































import {Component, Vue} from 'vue-property-decorator'
import ScheduleOptionSelector from "@/components/OptionSelector/ScheduleOptionSelector.vue";
import ScheduleListSorter from "@/components/ListSorter/ScheduleListSorter.vue";
import SchedulesStore from "@/store/modules/SchedulesStore";

@Component({
    components: {
        ScheduleListSorter,
        ScheduleOptionSelector,
    },
})

export default class ScheduleList extends Vue {
    private selected: string = "period";

    get scheduleIds() {
        return SchedulesStore.all.map(v => v.id);
    }

    get schedulePeriodIds() {
        return SchedulesStore.period.map(v => v.id);
    }

    get scheduleDayIds() {
        return SchedulesStore.day.map(v => v.id);
    }

    private onChangeSort(sortedIds: number[]) {
        SchedulesStore.localSort(sortedIds);
    }

    private onEndSort() {
        SchedulesStore.applySort();
    }

    private onSelectEdit() {
        this.$router.push({name: 'menu_schedule_create', query: { selected: this.selected}})
    }

    private onSelectDelete(scheduleId: number) {
        SchedulesStore.delete(scheduleId);
    }

    private isTabSelect(tab: string) {
        this.selected = tab;
    }
}

